import React from "react";

import { IDogClassElement, IEventRegisterInputElement } from "../FormBuilder";
import { IOption } from "../../Dropdown/Dropdown";

import Input from "../../Input/Input";

import './index.scss';

interface IProps {
  level: string // One of Constants.dog_class_element_level
  input: IEventRegisterInputElement;
  dogClass?: IDogClassElement;
  onChange: (input: IEventRegisterInputElement, value: IOption, extra?: string, extra_arr?: string, extra_level?: string) => void;
  label?: string;
  className?: string;
}

// NOTE: Hardcoded for 3 member
const ExtraTeammates: React.FC<IProps> = ({
                                            level,
                                            input,
                                            dogClass = undefined,
                                            onChange,
                                            label = undefined,
                                            className = ""
                                          }: IProps) => {
  return (
    <div className={"ExtraTeammates " + className}>
      {!!label && <p className="label">{label}</p>}
      <Input
        required
        type="text"
        id={input.id + "-extra_arr_0"}
        label="Team: Member 2 Registration #"
        defaultValue={(dogClass?.extra_arr ?? [])[0]}
        onChange={(e: any) => {
          e.stopPropagation();
          onChange(input, {
            id: "extra_arr_0",
            value: e.target.value
          }, undefined, e.target.value, level);
        }}
      />
      <Input
        required
        type="text"
        id={input.id + "-extra_arr_1"}
        label="Team: Member 3 Registration #"
        defaultValue={(dogClass?.extra_arr ?? [])[1]}
        onChange={(e: any) => {
          e.stopPropagation();
          onChange(input, {
            id: "extra_arr_1",
            value: e.target.value
          }, undefined, e.target.value, level);
        }}
      />
      <Input
        required
        type="text"
        id={input.id + "-extra_arr_2"}
        label="Team: Member 4 Registration #"
        defaultValue={(dogClass?.extra_arr ?? [])[2]}
        onChange={(e: any) => {
          e.stopPropagation();
          onChange(input, {
            id: "extra_arr_2",
            value: e.target.value
          }, undefined, e.target.value, level);
        }}
      />
    </div>
  )
}

export { ExtraTeammates };
